export const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3100/v1/';
export const tenorURL = process.env.REACT_APP_TENOR_BASE_URL || 'https://g.tenor.com/v1/';
export const tenorKey = process.env.REACT_APP_TENOR_KEY || 'EDDG32AIINBH';
export const merituURL = process.env.REACT_APP_MERITU_URL || 'http://localhost:3000/';
export const domainCookie = process.env.REACT_APP_DOMAIN_COOKIE || 'localhost';
// 'https://meritu-dotco2.uc.r.appspot.com/v1/'
